import { languageLabel } from './useLanguages';

export interface CaptionTrack {
  src: string;
  kind: 'captions';
  srclang: string;
  label: string;
  default: boolean;
  mode: 'showing' | 'disabled';
}

export interface CaptionTrackSources {
  originalUrl?: string;
  originalLanguage?: string | null;
  translation?: { language: string; url?: string } | null;
  showingLanguage?: string;
}

const track = (src: string, srclang: string, showingLanguage?: string): CaptionTrack => ({
  src,
  kind: 'captions',
  srclang,
  label: languageLabel(srclang),
  default: false,
  mode: showingLanguage === srclang ? 'showing' : 'disabled',
});

// The original file has no language of its own until detection ran, so it is
// labelled English, the same as before translations existed.
export const buildCaptionTracks = ({ originalUrl, originalLanguage, translation, showingLanguage }: CaptionTrackSources): CaptionTrack[] => {
  const tracks: CaptionTrack[] = [];

  if (originalUrl) {
    tracks.push(track(originalUrl, originalLanguage || 'en', showingLanguage));
  }

  if (translation?.url) {
    tracks.push(track(translation.url, translation.language, showingLanguage));
  }

  return tracks;
};
